import { NgModule } from '@angular/core';
import { FormatSecondsPipe } from './format-seconds.pipe';

@NgModule({
  declarations: [FormatSecondsPipe],
  imports: [],
  exports: [FormatSecondsPipe]
})
export class FormatSecondsModule {}
